export * from './IDataflow';
export * from './IDataFlowExpression';
export * from './IDataflowSource';

export type ComputeType = 'General' | 'ComputeOptimized' | 'MemoryOptimized';

export type ComputeSize = 'Small' | 'Medium' | 'Large' | 'Custom';

export enum DatasetFormatType {
    CDM = 'cdm',
    Delimited = 'delimited',
    Parquet = 'parquet',
    Avro = 'avro'
}
